import { render, staticRenderFns } from "./InformationPage.vue?vue&type=template&id=36602dec&"
import script from "./InformationPage.vue?vue&type=script&lang=js&"
export * from "./InformationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports